import React from "react";
import ICourseCard from "../../models/view/coursesPage/ICourseCard";
import s from '../../styles/components/courses/course-card.module.scss';
import {convertLevelToCssClass} from "../../services/courses/CourseCard";

interface ICourseCardProps {
  cardModel: ICourseCard,
  onClick: () => void,
}

export default function CourseCard({cardModel, onClick}: ICourseCardProps) {
  const {difficultyCategories, theme, imageUrl, lessonCount, description, name} = cardModel;

  return (
    <div className={`${s.courseCard} ${convertLevelToCssClass(theme)}`} onClick={onClick}>
      <div className={s.categories}>
        {difficultyCategories.map(((category, index) => (
          <div key={`difficultyCategory-${index}`}>{category}</div>
        )))}
      </div>
      <div className={s.image}>
        <img src={imageUrl} alt={``} width={93} height={93}/>
      </div>
      <div className={s.name}>{name}</div>
      <div className={s.description}>{description}</div>
      <div className={s.lessonCount}>{lessonCount} lessons</div>
    </div>
  );
}
